import {StringUtils} from './StringUtils';

export const ArgValidationErrorTypes = {
    Other: 'Other',
    IsNullOrUndefined: 'IsNullOrUndefined',
    StringIsNullOrEmpty: 'StringIsNullOrEmpty',
    NotNumber: 'NotNumber'
}

export class ArgValidator {
    public static ensureIsNotNullOrUndefined(obj: any, argName: string): void {
        var failure = obj === undefined || obj === null;
        if (failure) {
            throw new ArgValidationError(argName, ArgValidationErrorTypes.IsNullOrUndefined,
                'Parameter "' + argName + '" could not be null or undefined.');
        }
    }

    public static ensureIsNumber(obj: any, argName: string): void {
        ArgValidator.ensureIsNotNullOrUndefined(obj, argName);
        var type = typeof obj;
        var failure = type !== 'number';
        if (failure) {
            throw new ArgValidationError(argName, ArgValidationErrorTypes.NotNumber,
                'Parameter "' + argName + '" required type is number, actual is: ' + type);
        }
    }

    public static ensureStringIsNotNullOrEmpty(str: string, argName: string): void {
        var failure = StringUtils.isNullOrEmpty(str);
        if (failure) {
            throw new ArgValidationError(argName, ArgValidationErrorTypes.StringIsNullOrEmpty,
                'Parameter "' + argName + '" could not be null or undefined or empty string.');
        }
    }
}

export class ArgValidationError extends Error {
    public name = 'ArgValidationError';

    constructor(public arg: string, public type : string, public message: string) {
        super(message);
    }

    public equalsTo(other: ArgValidationError): boolean {
        if (other instanceof ArgValidationError) {
            return this.name === other.name &&
                this.arg === other.arg &&
                this.type === other.type;
        }

        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/ArgValidator.ts
 **/